;(function() {
  'use strict'

  angular.module('app.core').component('relocateDialog', {
    controller: Controller,
    templateUrl: 'relocate-dialog.html',
    bindings: {
      direction: '@',
      collection: '<',
      selectedItems: '<',
      getLabel: '&',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      switch (ctrl.direction) {
        case 'up':
          ctrl.directionTitle = 'above'
          var firstSelectedIndex = ctrl.collection.indexOf(
            _.head(ctrl.selectedItems)
          )
          ctrl.moveOptions = ctrl.collection
            .slice(0, firstSelectedIndex)
            .map(makeOption.bind(null, firstSelectedIndex))
          break
        case 'down':
          ctrl.directionTitle = 'below'
          var lastSelectedIndex = ctrl.collection.indexOf(
            _.last(ctrl.selectedItems)
          )
          ctrl.moveOptions = ctrl.collection
            .slice(lastSelectedIndex + 1, ctrl.collection.length)
            .map(makeOption.bind(null, lastSelectedIndex))
          break
      }
      ctrl.amount = null
    }

    function makeOption(selectedIndex, item) {
      var idx = ctrl.collection.indexOf(item)
      var amount = idx - selectedIndex
      return {
        label: ctrl.getLabel({ $item: item }),
        value: amount,
      }
    }
  }
})()
